// import $ from 'jquery';
import React from 'react';
import Select, { components } from 'react-select';
import Field from 'components/fields/Field';
import { isEmpty } from 'validator';
// import AsyncSelect from 'react-select/lib/Async';
// import PropTypes from 'prop-types';

const DropdownIndicator = (props) => {
    const { indicatorText } = props.selectProps;
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                {indicatorText}
            </components.DropdownIndicator>
        )
    );
};
const IndicatorsContainer = (props) => {
    const { limit, value, isMulti } = props.selectProps;

    if (isMulti && (typeof value == 'Array' && value.length >= limit))
        return null;
    return <components.IndicatorsContainer {...props} />;
};
const Option = (props) => {
    const { data } = props;
    let { className } = props;

    if (typeof data.className != 'undefined') {
        className += ' ' + data.className;
    }

    return (
        components.Option && (
            <components.Option {...props} className={className} />
        )
    );
};

class FieldCustomSelect extends Field {
    constructor(props) {
        super(props);
    }
    // format(value) {
    // }
    // validate() {
    // }
    handleClasses() {
        let classes = super.handleClasses().concat(' react-select');

        return classes;
    }
    handleSearchbale() {
        const { isSearchable, limit, value, isMulti } = this.props;
        if (isMulti && value.length >= limit) return false;
        return isSearchable || false;
    }
    getDefaultStyles() {
        const { isMulti, styles } = this.props;
        // const hasAutoresize = this.hasAutoresize();

        let finalStyles = {
            container: (base, state) => ({
                ...base,
                // position: hasAutoresize ? 'absolute' : base.position,
                // top: hasAutoresize ? 0 : base.top,
                // left: hasAutoresize ? 0 : base.left,
                // right: hasAutoresize ? 0 : base.right,
                // bottom: hasAutoresize ? 0 : base.bottom,
            }),
            control: (base, state) => ({
                ...base,
                padding: '6px 0 7px 0',
                border: '1px solid #e1e1e1',
                borderRadius: 0,
                background: 'none',
                boxShadow: 'none',
                minHeight: '30px',
                cursor: 'pointer', // Maybe change
            }),
            menu: (base, state) => ({
                ...base,
                minWidth: '100%',
                width: 'auto',
                margin: 0,
                borderRadius: 0,
                // background: 'none',
                // boxShadow: 'none',
            }),
            menuList: (base, state) => ({
                ...base,
                overflowX: 'hidden',
                overflowY: 'auto',
            }),
            multiValueRemove: (base, state) => ({
                ...base,
                background: 'none !important',
            }),
            multiValueLabel: (base, state) => ({
                ...base,
                color: 'inherit',
                paddingLeft: false,
                borderRadius: 0,
                fontSize: '1em',
            }),
            placeholder: (base, state) => ({
                ...base,
                color: 'hsl(0,0%,60%)',
                position: 'static',
                marginLeft: 0,
                marginRight: '10px',
                transform: 'none',
            }),
            dropdownIndicator: (base, state) => ({
                ...base,
            }),
            indicatorSeparator: (base, state) => ({
                ...base,
                // display: 'none',
            }),
            indicatorsContainer: (base, state) => ({
                ...base,
                // display: !isMulti ? 'none' : base.display,
            }),
            valueContainer: (base, state) => ({
                ...base,
                fontSize: '0.75em',
            }),
            singleValue: (base, state) => ({
                ...base,
                margin: 0,
                maxWidth: '100%',
                color: 'inherit',
                // position: 'relative',
                top: false,
                transform: 'none',
                overflow: 'hidden',
            }),
            multiValue: (base, state) => ({
                ...base,
                // borderRadius: 0,
                padding: '5px',
            }),
            input: () => ({
                // margin: '0 0 0 10px'
            }),
        };

        if (typeof styles != 'undefined' && styles) {
            finalStyles = {
                ...finalStyles,
                ...styles,
            };
        }

        return finalStyles;
    }
    getSelectedOptions(value) {
        const { options, isMulti } = this.props;
        let selectedOptions = [];

        options.forEach((option) => {
            if (typeof option.options != 'undefined') {
                let selectedOption = [];
                if (value instanceof Array) {
                    selectedOption = option.options.filter(
                        (item, index) => {
                            return value.includes(item.value);
                        }
                    );
                } else {
                    selectedOption = option.options.find(
                        (item, index) => {
                            return String(item.value).toLowerCase() ===
                                String(value).toLowerCase();
                        }

                    );
                }
                if (
                    typeof selectedOption != 'undefined' &&
                    selectedOption != null &&
                    selectedOption
                ) {
                    if (selectedOption instanceof Array) {
                        selectedOptions = [...selectedOptions, ...selectedOption];
                    } else {
                        selectedOptions = [...selectedOptions, selectedOption];
                    }
                }
            } else {
                if (
                    String(option.value).toLowerCase() ===
                    String(value).toLowerCase()
                ) {
                    selectedOptions = [...selectedOptions, option];
                }
            }
        });

        if (isMulti) {
            return selectedOptions;
        }

        return selectedOptions.length > 0 ? selectedOptions[0] : null;
    }
    generateSelectedOptions(value) {
        const { limit } = this.props;
        if (value instanceof Array) {
            if (value.length > limit) {
                return false;
            }
            return value.map((item) => item.value);
        }

        if (value != null) {
            return value.value;
        }

        return false;
    }
    onChange(value, action) {
        const { onChange, name } = this.props;
        const newValue = this.generateSelectedOptions(value);

        // if (!newValue) return false;
        if (onChange) {
            onChange(name, newValue);
        }
    }
    // hasAutoresize() {
    //     const { autoResize, isMulti, value } = this.props;
    //     return isMulti ? autoResize && !value : autoResize;
    // }
    renderAutoresize() {
        const { placeholder, autoResize, isMulti, value } = this.props;
        const option = this.getSelectedOptions(value);
        if (!autoResize) return null;
        if (isMulti) {
            if (value) return null;
            return (
                <div className='field__input field__input--autoresize'>
                    {placeholder}
                </div>
            );
        }
        return (
            <div className='field__input field__input--autoresize' dangerouslySetInnerHTML={{ __html: option.label }} />
        );
    }
    render() {
        const {
            options,
            isMulti,
            isClearable,
            value,
            placeholder,
            limit,
            indicatorText,
            noOptionsMessage,
            disabled,
            isLoading,
            style,
        } = this.props;
        const selectedValue = this.getSelectedOptions(value);

        return (
            <label
                className={this.handleClasses()}
                data-label={super.renderAnimatedLabel()}
                ref={(r) => (this.field = r)}
                style={style}
            >
                {super.renderLabel()}
                <Select
                    ref={(r) => (this.input = r)}
                    // custom props
                    limit={limit}
                    fieldClasses='field__input'
                    indicatorText={indicatorText}
                    // end custom props
                    arrowRenderer={false}
                    value={selectedValue}
                    options={options}
                    placeholder={placeholder}
                    // menuIsOpen={true}
                    components={{
                        IndicatorsContainer,
                        DropdownIndicator,
                        Option,
                    }}
                    isDisabled={disabled || isLoading || false}
                    isLoading={isLoading || false}
                    isMulti={isMulti || false}
                    isSearchable={this.handleSearchbale()}
                    isClearable={isClearable || false}
                    className='react-select__container'
                    classNamePrefix='react-select'
                    onChange={(value, action) => this.onChange(value, action)}
                    onMenuOpen={() => {
                        super.setState({
                            isFocused: true,
                        });
                    }}
                    onMenuClose={() => {
                        super.setState({
                            isFocused: false,
                        });
                    }}
                    styles={this.getDefaultStyles()}
                    noOptionsMessage={noOptionsMessage}
                    formatOptionLabel={(data) => <span dangerouslySetInnerHTML={{ __html: data.label }} />}
                />
                {super.renderError()}
                {super.renderLoading()}
            </label>
        );
    }
}

export default FieldCustomSelect;
